import { render, staticRenderFns } from "./PromoUpdate.vue?vue&type=template&id=1f802146&scoped=true"
import script from "./PromoUpdate.vue?vue&type=script&lang=js"
export * from "./PromoUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f802146",
  null
  
)

export default component.exports